import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'http://localhost:3000/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

/*const apiClient2 = axios.create({
  baseURL: 'https://api.sendgrid.com/v3',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization:
      'Bearer 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'
  }
})*/

/* using axios interceptors for progress bar
note: for future implementations, put interceptors 
in their own module keeping track of how many api calls
are pending (in the event we have more than 1 api call)

import NProgress from 'nprogress'

apiClient.interceptors.request.use(config => {
  NProgress.start()
  return config
})

apiClient.interceptors.response.use(response => {
  NProgress.done()
  return response
})

*/

export default {
  getEvents(perPage, page) {
    return apiClient.get('/events?_limit=' + perPage + '&_page=' + page)
  },
  getEvent(id) {
    return apiClient.get('/events/' + id)
  },
  postEvent(event) {
    return apiClient.post('/events/', event)
  } /*,
  getMailSettings() {
    return apiClient2.get('/mail-settings/')
  }*/
}
